import { Box, styled } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const FormWrapper = styled(Box)({
  padding: "20px 0",
});
export const FormTitle = styled(Box)({
  fontWeight: "bold",
  fontSize: "18px",
  marginBottom: "20px",
  marginLeft: "25px",
});

export const FormContainer = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  marginBottom: "50px",
  flexDirection: "column",
});

export const FieldContainer = styled(Box)({
  width: "325px",
  margin: "5px 25px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  "& .MuiFormLabel-root": {
    marginBottom: "9px",
  },
  "& .MuiInputBase-root": {
    minWidth: "100%",
    minHeight: "30px",
    border: "1px solid #b2b9dc",
    borderRadius: "4px",
    "& input": {
      paddingLeft: "10px",
      paddingRight: "10px",
      paddingBottom: "0px",
      paddingTop: "0px",
    },
  },
});

export const ButtonsContainer = styled(Box)({
  margin: "0 25px",
  textAlign: "center",
  "& .MuiButtonBase-root": {
    marginRight: "18px",
    height: "26px",
    fontSize: "12px",
  },
});
export const SectionContainer = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
});

export const HeaderButtonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "10px",
  color: theme.palette.primary.main,
  "& div": {
    cursor: "pointer",
  },
}));

export const ArrowBack = styled(ArrowBackIcon)(({ theme }) => ({
  marginRight: "10px",
  cursor: "pointer",
}));
